/*
- Description: This file contains all the routes to different components and features of the application
- Feature: wrote from Scratch
- Author: Trushita Maurya, Guryash Singh Dhall, Shiva Shankar, Haoran Wang
*/

import React, { Suspense, useState } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Loader from "./components/Loader";
import Settings from "./views/Settings";
import LoginPage from "./views/LoginPage";
import SignUpPage from "./views/SignUpPage";

//imports are lazy loaded for better performance and to reduce size of bundle.
const HomePage = React.lazy(() => import("./views/HomePage"));

const Dashboard = React.lazy(() => import("./views/Dashboard"));
const EntrepreneurDetailsPage = React.lazy(() =>
  import("./views/EnterpreneurDetailsPage")
);
const EnterpreneurProfilePage = React.lazy(() =>
  import("./views/EnterpreneurProfilePage")
);
const BackgroundCheckPage = React.lazy(() =>
  import("./views/BackgroundCheckPage")
);
const InvestorDetailsPage = React.lazy(() =>
  import("./views/InvestorDetailsPage")
);

// payments page loading lazily
const Payment = React.lazy(() => import("./components/payments/payment"));
// confimration page loading lazily
const Confirmation = React.lazy(() =>
  import("./components/payments/confirmation")
);
// subscription page loading lazily
const Subscription = React.lazy(() =>
  import("./components/payments/subscription")
);

const LoanCalculator = React.lazy(() => import("./components/LoanCalculator"));
const InvestorHomePage = React.lazy(() => import("./views/InvestorHomePage"));
const InvestorViewPage = React.lazy(() => import("./views/InvestorViewPage"));
const EntrepreneurViewPage = React.lazy(() =>
  import("./views/EntrepreneurViewPage")
);
const EnterpreneurHome = React.lazy(() =>
  import("./views/EnterpreneurHomePage")
);

const Router = () => {
  const [user, setUser] = useState(null);
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Switch>
          <Route
            exact
            path="/login"
            render={() => {
              return <LoginPage setUser={setUser} />;
            }}
          />

          <Route
            exact
            path="/signup"
            render={() => {
              return <SignUpPage />;
            }}
          />
          <Route
            exact
            path="/"
            render={() => {
              return <HomePage />;
            }}
          />
          <Route
            exact
            path="/dashboard"
            render={() => {
              return <Dashboard />;
            }}
          />
          <Route
            exact
            path="/enterpreneurProfile"
            render={() => {
              return <EnterpreneurProfilePage />;
            }}
          />
          <Route
            exact
            path="/enterpreneurDetails"
            render={() => {
              return <EntrepreneurDetailsPage />;
            }}
          />
          <Route
            exact
            path="/investorProfile"
            render={() => {
              return <Dashboard />;
            }}
          />
          <Route
            exact
            path="/settings"
            render={() => {
              return <Settings />;
            }}
          />
          <Route
            exact
            path="/investorDetails"
            render={() => {
              return <InvestorDetailsPage />;
            }}
          />

          <Route
            exact
            path="/background-check"
            render={() => {
              return <BackgroundCheckPage />;
            }}
          />

          <Route
            exact
            path="/investorViewPage"
            render={() => {
              return <InvestorViewPage />;
            }}
          />
          <Route
            exact
            path="/entrepreneurViewPage"
            render={() => {
              return <EntrepreneurViewPage />;
            }}
          />

          <Route
            exact
            path="/investorHomePage"
            render={() => {
              return <InvestorHomePage />;
            }}
          />
          <Route
            exact
            path="/enterpreneurHomePage"
            render={() => {
              return <EnterpreneurHome />;
            }}
          />
          <Route
            exact
            path="/loanCalculator"
            render={() => {
              return <LoanCalculator />;
            }}
          />

          {/* payment page route linked with the component lazily being loaded */}
          <Route
            exact
            path="/payment"
            render={() => {
              return <Payment />;
            }}
          />
          {/* payment confirmation page route linked with the component being lazily loaded */}
          <Route
            exact
            path="/payment-confirmation"
            render={() => {
              return <Confirmation />;
            }}
          />
          {/* subscriptions listing page route linked with the component being lazily loaded */}
          <Route
            exact
            path="/subscription"
            render={() => {
              return <Subscription />;
            }}
          />
        </Switch>
      </Suspense>
    </BrowserRouter>
  );
};

export default Router;
